/* BUSINESS INFORMATION */
const business = {
  name: 'Move-Land',
  phone: '(516) 908-1446',
  email: 'info@move-land.com',
  logo: true
};

export default business;